export const bloquearNaoDigitos = (e) => {
  if (e.ctrlKey || e.metaKey || e.altKey) return;
  const allow = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
  if (allow.includes(e.key)) return;
  if (!/^\d$/.test(e.key)) e.preventDefault();
};
